import { render, staticRenderFns } from "./SearchHotelsTabContent.vue?vue&type=template&id=4b7415ea&"
import script from "./SearchHotelsTabContent.vue?vue&type=script&lang=js&"
export * from "./SearchHotelsTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
